
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.3 13.802a1.136 1.136 0 00-.8-.3 1.11 1.11 0 00-1.1 1.1v3.8H2.2v-3.8a1.11 1.11 0 00-1.1-1.1 1.11 1.11 0 00-1.1 1.1v4.9c-.008.295.1.582.3.8.218.2.505.308.8.3h18.5a1.11 1.11 0 001.1-1.1v-4.9a1.506 1.506 0 00-.4-.8z","fill":"#1D1D1D"}}),_c('path',{attrs:{"d":"M9.8 15.002l.2.2a1.09 1.09 0 001.1-.2l4.9-5.2a1.061 1.061 0 00-1.5-1.5l-3 3.2v-10.4a1.11 1.11 0 00-1.1-1.1 1.135 1.135 0 00-1.2 1.1v10.3l-2.9-3.2a2.01 2.01 0 00-.8-.4 1.08 1.08 0 00-.7.3 1.116 1.116 0 00-.1 1.6l5.1 5.3z","fill":"#1D1D1D"}})])
          )
        }
      }
    